import React, { useState, useEffect } from 'react';
import './gestionProfesionales.css';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faCalendarAlt, faUser, faEnvelope, faPhone, faChevronLeft, faSave, faExclamationTriangle, faPenToSquare, faEye } from '@fortawesome/free-solid-svg-icons';
import { useAuthServices } from '../../services/useFetch';
import AgendaProfesional from '../Agenda/AgendaProfesional';

const GestionProfesionales = () => {

    const { requestPost } = useAuthServices();

    const [modalError000, setModalError000] = useState(false)
    const [modalError001, setModalError001] = useState(false)
    const [modalError002, setModalError002] = useState(false)

    const [profesionales, setProfesionales] = useState([]);
    const [profesionalSeleccionado, setProfesionalSeleccionado] = useState(null);

    const [vista, setVista] = useState('LISTA');

    const [nuevoProfesional, setNuevoProfesional] = useState({
        nombres: '',
        apellidos: '',
        identificacion: '',
        correo: '',
        telefono: '',
        idProfesional: 0
    });

    const [formState, setFormState] = useState({
        nombresRef: false,
        apellidosRef: false,
        identificacionRef: false,
        correoRef: false,
        telefonoRef: false
    });

    useEffect(() => {
        obtieneListadoProfesionales();
    }, []);

    const obtieneListadoProfesionales = async () => {
        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!usuarioLocalStorage) {
            return;
        }
        const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
        const body = {
            idCompany: usuarioLocalStorageObj.idCompany
        };
        const response = await requestPost(body, 21);
        if (!response.error) {
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setProfesionales(objeto);
            } else {
                if (mensaje === 'AT_BCK_001') {
                    setModalError001(true)
                } else if (mensaje === 'AT_BCK_002') {
                    setModalError002(true)
                } else {
                    setModalError000(true)
                }
            }
        }
    };

    const handleInputChange = (e) => {
        setNuevoProfesional({
            ...nuevoProfesional,
            [e.target.name]: e.target.value
        });
        setFormState(prev => ({
            ...prev,
            [`${e.target.name}Ref`]: false
        }));
    };

    const guardarProfesional = async () => {
        const errors = {
            nombresRef: !nuevoProfesional.nombres.trim(),
            apellidosRef: !nuevoProfesional.apellidos.trim(),
            identificacionRef: !nuevoProfesional.identificacion.trim(),
            correoRef: !nuevoProfesional.correo.trim(),
            telefonoRef: !nuevoProfesional.telefono.trim()
        };
        setFormState(errors);

        if (Object.values(errors).some(error => error)) {
            return;
        }

        const usuarioLocalStorage = sessionStorage.getItem('usuarioApp');
        if (!usuarioLocalStorage) {
            return;
        }

        const usuarioLocalStorageObj = JSON.parse(usuarioLocalStorage);
        const body = {
            ...nuevoProfesional,
            idCompany: usuarioLocalStorageObj.idCompany
        };
        const response = await requestPost(body, 20);
        if (!response.error) {
            const { estado, mensaje } = response.data;
            if (estado) {
                setNuevoProfesional({
                    nombres: '',
                    apellidos: '',
                    identificacion: '',
                    correo: '',
                    telefono: '',
                    idProfesional: 0
                });
                setFormState({
                    nombresRef: false,
                    apellidosRef: false,
                    identificacionRef: false,
                    correoRef: false,
                    telefonoRef: false
                });
                setVista('LISTA');
                obtieneListadoProfesionales();
            } else {
                if (mensaje === 'AT_BCK_001') {
                    setModalError001(true)
                } else if (mensaje === 'AT_BCK_002') {
                    setModalError002(true)
                } else {
                    setModalError000(true)
                }
            }
        } else {
            setModalError000(true)
        }
    };

    const verAgendaProfesional = (profesional) => {
        setProfesionalSeleccionado(profesional);
        setVista('AGENDA_PROFESIONAL');
    };

    const crearProfesional = () => {
        setNuevoProfesional({
            nombres: '',
            apellidos: '',
            identificacion: '',
            correo: '',
            telefono: '',
            idProfesional: 0
        });
        setVista('FORMULARIO');
    };

    const editarInfoProfesional = (profesional) => {
        setNuevoProfesional({
            nombres: profesional.nombres,
            apellidos: profesional.apellidos,
            identificacion: profesional.identificacion,
            correo: profesional.correo,
            telefono: profesional.telefono,
            idProfesional: profesional.id
        });
        setVista('FORMULARIO');
    };

    const handleCloseModalError000 = () => {
        setModalError000(false)
    };

    const handleCloseModalError001 = () => {
        setModalError001(false)
    };

    const handleCloseModalError002 = () => {
        setModalError002(false)
    };

    const renderLista = () => (
        <>
            <div className="div-container-gestion-profesionales">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h1 className='size-db-info-agenda-h1'>
                        Profesionales Registrados
                    </h1>
                    <button className="bottom-custom" onClick={() => crearProfesional()}>
                        <FontAwesomeIcon icon={faPlus} className="me-2" /> Nuevo Profesional
                    </button>
                </div>
                <div className="table-profesionales">
                    <table className="table table-hover table-responsive ">
                        <thead className="table-light">
                            <tr>
                                <th>Nombre Completo</th>
                                <th>Identidad / Profesión</th>
                                <th>Contacto</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {profesionales.length > 0 ? (
                                profesionales.map((prof) => (
                                    <tr key={prof.id}>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <div className="avatar-placeholder me-2 bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center" style={{ width: '35px', height: '35px', position: 'relative' }}>
                                                    <FontAwesomeIcon icon={faUser} />
                                                    <span
                                                        style={{
                                                            position: 'absolute', bottom: 0, right: 0,
                                                            width: '12px', height: '12px',
                                                            borderRadius: '50%', backgroundColor: prof.usuarioActivo !== false ? '#28a745' : '#dc3545',
                                                            border: '2px solid white'
                                                        }}
                                                    ></span>
                                                </div>
                                                <div>
                                                    <div>{prof.nombres} {prof.apellidos}</div>
                                                    {prof.usuario && <div className="small text-muted">@{prof.usuario}</div>}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div>{prof.identificacion}</div>
                                            {prof.role && <div className="small text-muted">{prof.role}</div>}
                                        </td>
                                        <td>
                                            <div className="small text-muted">
                                                <div><FontAwesomeIcon icon={faEnvelope} className="me-1" /> {prof.correo}</div>
                                                <div><FontAwesomeIcon icon={faPhone} className="me-1" /> {prof.telefono}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <button className="" style={{ border: 'none', backgroundColor: 'transparent', color: 'blue' }} onClick={() => verAgendaProfesional(prof)}>
                                                <FontAwesomeIcon icon={faCalendarAlt} />
                                            </button>
                                            <button className="" style={{ border: 'none', backgroundColor: 'transparent', color: 'blue' }} onClick={() => editarInfoProfesional(prof)}>
                                                <FontAwesomeIcon icon={faPenToSquare} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-muted">No hay profesionales registrados.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );

    const renderFormulario = () => (
        <>
            <div className="div-container-gestion-profesionales">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="size-db-info-agenda-h1">Registrar Nuevo Profesional</h2>
                    <button className="btn btn-link text-decoration-none ps-0" onClick={() => setVista('LISTA')}>
                        <FontAwesomeIcon icon={faChevronLeft} className="me-1" /> Volver a la lista
                    </button>
                </div>
                <div className="card shadow-sm border-0">
                    <div className="card-body p-4">
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">Nombres</label>
                                <input type="text" className={formState.nombresRef ? 'form-control form-control-error' : 'form-control'} name="nombres" value={nuevoProfesional.nombres} onChange={handleInputChange} placeholder="" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Apellidos</label>
                                <input type="text" className={formState.apellidosRef ? 'form-control form-control-error' : 'form-control'} name="apellidos" value={nuevoProfesional.apellidos} onChange={handleInputChange} placeholder="" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Identificación</label>
                                <input type="text" className={formState.identificacionRef ? 'form-control form-control-error' : 'form-control'} name="identificacion" value={nuevoProfesional.identificacion} onChange={handleInputChange} placeholder="" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Correo Electrónico</label>
                                <input type="email" className={formState.correoRef ? 'form-control form-control-error' : 'form-control'} name="correo" value={nuevoProfesional.correo} onChange={handleInputChange} placeholder="" />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Teléfono</label>
                                <input type="text" className={formState.telefonoRef ? 'form-control form-control-error' : 'form-control'} name="telefono" value={nuevoProfesional.telefono} onChange={handleInputChange} placeholder="" />
                            </div>
                        </div>
                        <div className="mt-4 d-flex justify-content-center gap-2">
                            <button className="bottom-custom-secondary" onClick={guardarProfesional}>
                                <FontAwesomeIcon icon={faSave} /> Guardar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    const renderAgendaProfesional = () => {
        return (
            <>
                <div className="div-container-gestion-profesionales">
                    <div className="d-flex justify-content-between align-items-center mb-0">
                        <h2 className="size-db-info-agenda-h1">Agenda Profesional: </h2>
                        <h4 className="size-db-info-agenda-h2">{profesionalSeleccionado.nombres} {profesionalSeleccionado.apellidos}</h4>
                        <button className="btn btn-link text-decoration-none ps-0" onClick={() => setVista('LISTA')}>
                            <FontAwesomeIcon icon={faChevronLeft} className="me-1" /> Volver a la lista
                        </button>
                    </div>
                </div>
                <AgendaProfesional profesionalSeleccionado={profesionalSeleccionado} />
            </>
        )
    }

    const renderControl = () => {
        switch (vista) {
            case 'LISTA':
                return renderLista();
            case 'FORMULARIO':
                return renderFormulario();
            case 'AGENDA_PROFESIONAL':
                return renderAgendaProfesional();
            default:
                return <></>
        }
    }

    return (
        <>
            {
                renderControl()
            }
            <Modal isOpen={modalError000} onHide={handleCloseModalError000} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>No pudimos completar tu solicitud<FontAwesomeIcon icon={faExclamationTriangle} className='icon-error mx-3' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Hubo un inconveniente al procesar la información. Por favor, inténtalo nuevamente en unos instantes o verifica tu conexión.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseModalError000}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalError001} onHide={handleCloseModalError001} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Usuario ya registrado <FontAwesomeIcon icon={faExclamationTriangle} className='icon-warning' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>Parece que ya hay un usuario registrado con el correo electrónico proporcionado. verifica la información y vuelve a intentarlo.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseModalError001}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={modalError002} onHide={handleCloseModalError002} className='modal-perfil-cliente'>
                <ModalHeader closeButton>
                    <h4>Correo en formato incorrecto <FontAwesomeIcon icon={faExclamationTriangle} className='icon-warning' /> </h4>
                </ModalHeader>
                <ModalBody>
                    <p>El correo electrónico debe tener un formato válido. Por favor, verifica que el correo electrónico tenga un formato correcto.</p>
                </ModalBody>
                <ModalFooter>
                    <Button variant="primary" onClick={handleCloseModalError002}>
                        Aceptar
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    );
};

export default GestionProfesionales;
